const HowItWorksContent = () => {
  return (
    <div>
      <p className="mt-4 text-base leading-6 text-gray-700">
        Datasets help you organize and reuse the files in your runs.
      </p>

      <h3 className="mt-4 text-lg font-semibold text-gray-900">How it works</h3>
      <div className="mt-3 space-y-4 text-base leading-6 text-gray-900">
        <div>
          <div className="font-semibold">Add</div>
          <div className="mt-1 text-gray-700">
            When you add a new item, it’s saved to the selected{" "}
            <span className="font-semibold">Sample Tracker</span> first, then
            it’s referenced in this dataset.
          </div>
        </div>
        <div>
          <div className="font-semibold">Edit</div>
          <div className="mt-1 text-gray-700">
            When you edit an item here, you’re editing the source in the{" "}
            <span className="font-semibold">Sample Tracker</span>
            —so the dataset updates automatically.
          </div>
        </div>
        <div>
          <div className="font-semibold">Remove</div>
          <div className="mt-1 text-gray-700">
            <p>
              When you remove an item from a dataset, it{" "}
              <span className="font-semibold">only</span> removes it from this
              dataset. The item stays in the Sample Tracker.
            </p>
          </div>
        </div>
        <h3 className="!mt-8 text-lg font-semibold text-gray-900">
          Important to know
        </h3>
        <p className="mt-2 text-base leading-6 text-gray-900">
          We don’t upload or store the actual file here. We keep a record of
          where it lives (Cloud, HPC, GEO, BaseSpace etc.)
        </p>
      </div>
    </div>
  );
};

export default HowItWorksContent;
